import { render, staticRenderFns } from "./SphericalContainer.vue?vue&type=template&id=7f99ef44&"
import script from "./SphericalContainer.vue?vue&type=script&lang=js&"
export * from "./SphericalContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/semaphore/fabric-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f99ef44')) {
      api.createRecord('7f99ef44', component.options)
    } else {
      api.reload('7f99ef44', component.options)
    }
    module.hot.accept("./SphericalContainer.vue?vue&type=template&id=7f99ef44&", function () {
      api.rerender('7f99ef44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/SphericalContainer.vue"
export default component.exports